const WA_LINK = "https://wa.me/5554996914900?text=Ol%C3%A1%2C%20gostaria%20de%20uma%20an%C3%A1lise%20do%20meu%20contrato%20banc%C3%A1rio.";
const ANALYSIS_LINK = "https://wa.me/5554996914900?text=Ol%C3%A1%2C%20gostaria%20de%20solicitar%20a%20an%C3%A1lise%20do%20meu%20contrato%20banc%C3%A1rio.";

export default function Hero() {
  const scrollTo = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="inicio"
      className="relative min-h-screen flex items-center overflow-hidden"
      style={{ background: "linear-gradient(135deg, #1A1A1A 0%, #2C2C2C 50%, #1A1A1A 100%)" }}
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=professional%20law%20office%20interior%20dark%20elegant%20mahogany%20desk%20scales%20of%20justice%20leather%20bound%20legal%20books%20sophisticated%20warm%20amber%20lighting%20black%20and%20dark%20tones%20prestigious%20Brazilian%20courthouse%20minimal%20clean%20wide%20angle%20no%20people%20dramatic%20shadows&width=1920&height=1080&seq=hero01&orientation=landscape"
          alt="Escritório de advocacia"
          className="w-full h-full object-cover object-center opacity-25"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#1A1A1A]/95 via-[#1A1A1A]/80 to-[#1A1A1A]/60" />
      </div>

      {/* Red accent line top */}
      <div className="absolute top-0 left-0 right-0 h-1 bg-[#B32025]" />

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-10 pt-32 pb-20">
        <div className="max-w-3xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-[#B32025]/15 border border-[#B32025]/30 px-4 py-2 rounded-full mb-8">
            <div className="w-2 h-2 rounded-full bg-[#B32025] animate-pulse" />
            <span className="text-[#B32025] text-xs font-semibold uppercase tracking-widest">
              Especialista em Juros Abusivos
            </span>
          </div>

          {/* H1 */}
          <h1 className="font-serif text-white text-3xl lg:text-4xl xl:text-5xl font-bold leading-snug mb-8">
            20 anos de experiência em{" "}
            <em className="text-[#B32025] not-italic">Direito Bancário</em>
          </h1>

          {/* Bloco de destaque */}
          <div className="border-l-4 border-[#B32025] bg-white/5 rounded-r-lg px-6 py-5 mb-8 space-y-3">
            <div className="flex items-start gap-3">
              <div className="w-5 h-5 flex items-center justify-center text-[#B32025] mt-0.5 shrink-0">
                <i className="ri-checkbox-circle-fill text-lg leading-none" />
              </div>
              <p className="text-white text-lg lg:text-xl font-semibold leading-snug">
                Parcela atual reduzida em{" "}
                <span className="text-[#B32025]">até metade do valor</span>
              </p>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-5 h-5 flex items-center justify-center text-[#B32025] mt-0.5 shrink-0">
                <i className="ri-checkbox-circle-fill text-lg leading-none" />
              </div>
              <p className="text-white text-lg lg:text-xl font-semibold leading-snug">
                Possibilidade de quitação total do contrato com{" "}
                <span className="text-[#B32025]">descontos de até 90%</span>
              </p>
            </div>
          </div>

          <p className="text-[#BFBFBF] text-base lg:text-lg leading-relaxed mb-10 font-sans">
            Somos da <strong className="text-white">Ivan Carlos Revisões de Juros</strong>. Temos mais de 20 anos de experiência em{" "}
            <strong className="text-white">Direito Bancário / Revisões de Juros / Repetição de Indébito</strong>.
            Podemos colocar a sua parcela atual pela metade do seu valor e lhe proporcionar uma quitação da totalidade do seu contrato junto à financeira com descontos de até{" "}
            <strong className="text-white">90%</strong> — e ainda resgatar para você o valor que já foi pago em juros abusivos, corrigidos conforme a legislação vigente.
          </p>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href={WA_LINK}
              target="_blank"
              rel="noopener noreferrer"
              className="group flex items-center justify-center gap-3 bg-[#B32025] hover:bg-[#8E1A1E] text-white font-semibold px-8 py-4 rounded-md transition-all duration-200 whitespace-nowrap cursor-pointer text-base"
            >
              Saiba como podemos te ajudar
              <div className="w-4 h-4 flex items-center justify-center transition-transform group-hover:translate-x-1">
                <i className="ri-arrow-right-line text-sm leading-none" />
              </div>
            </a>

            <a
              href={ANALYSIS_LINK}
              target="_blank"
              rel="noopener noreferrer"
              className="group flex items-center justify-center gap-2 border border-white/30 hover:border-white/60 text-white hover:bg-white/10 font-medium px-8 py-4 rounded-md transition-all duration-200 whitespace-nowrap cursor-pointer text-base"
            >
              Solicitar análise do contrato
            </a>
          </div>

          {/* Trust indicators */}
          <div className="flex flex-wrap items-center gap-6 mt-12 pt-10 border-t border-white/10">
            {[
              { icon: "ri-time-line", text: "Resposta rápida" },
              { icon: "ri-award-line", text: "Especialista em revisão de juros" },
            ].map((item) => (
              <div key={item.text} className="flex items-center gap-2">
                <div className="w-5 h-5 flex items-center justify-center text-[#B32025]">
                  <i className={`${item.icon} text-base leading-none`} />
                </div>
                <span className="text-[#BFBFBF] text-sm font-sans">{item.text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <button
        onClick={() => scrollTo("#problema")}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 w-8 h-8 flex items-center justify-center text-white/40 cursor-pointer animate-bounce hover:text-white/70 transition-colors"
        aria-label="Rolar para baixo"
      >
        <i className="ri-arrow-down-line text-xl leading-none" />
      </button>
    </section>
  );
}
